import { isQueryDebugOverridden } from './core/debug-override-registry.js';
import { type useGetMarketArgs, useGetMarketSpec } from './generated/specs/markets.spec.gen.js';

/** True when the market-detail query currently renders engineer-injected data. */
export function isMarketDetailDebugOverridden(args: useGetMarketArgs): boolean {
  const factory = useGetMarketSpec.entityKeys.detail;
  return factory !== undefined && isQueryDebugOverridden(factory(args).queryKey);
}
